import { render, staticRenderFns } from "./ModelSave.vue?vue&type=template&id=61139bd6&scoped=true"
import script from "./ModelSave.vue?vue&type=script&lang=js"
export * from "./ModelSave.vue?vue&type=script&lang=js"
import style0 from "./ModelSave.vue?vue&type=style&index=0&id=61139bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61139bd6",
  null
  
)

export default component.exports